import React from 'react';
import advocateProfilePic from '../../../assets/images/advocates-details/kathyayan.png';

const AdvocateKathyayanDetails = () => {
  return (
    <section className='team-details'>
      <div className='container'>
        <div className='row justify-content-between'>
          <div className='col-lg-5'>
            <div className='team-details__content'>
              <h2 className='team-details__title'>Read my story</h2>
              <p className='team-details__text'>
                Kathya pursued his Master of Laws in International Law from
                University of Essex, United Kingdom and Bachelor's Degree
                BBA.LLB (Hon's) from ICFAI Law School, Hyderabad. He enrolled
                in the year 2025 as an Advocate and currently practicing at
                Trial courts and Forums of Telangana dealing in all Civil,
                Family and Criminal matters.
              </p>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='team-one__single'>
              <div className='team-one__image' style={{ textAlign: 'center' }}>
                <img
                  src={advocateProfilePic}
                  alt='N. Kathyayan Reddy'
                  style={{
                    objectFit: 'cover',
                    objectPosition: 'center center',
                    display: 'block',
                    margin: '0 auto',
                    maxWidth: '100%',
                    height: 'auto',
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none'
                  }}
                />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  N. KATHYAYAN REDDY, LLM International Law (UK)
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvocateKathyayanDetails;

